import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);

    _defineProperty(this, "_telemetryClient", null);

    _defineProperty(this, "_telemetryConfigObject", {
      enableConsoleLog: true,
      isDevelopmentMode: true,
      logDependenciesEnabled: true,
      logEventsEnabled: true,
      logExceptionsEnabled: true,
      logMetricesEnabled: true,
      logRequestsEnabled: true,
      logTracesEnabled: true
    });
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(telemetryClient, telemetryConfig) {
      this._telemetryClient = telemetryClient;
      this._telemetryConfigObject = telemetryConfig;
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName) {
      var customProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._telemetryClient || !this._telemetryConfigObject.logEventsEnabled) return;

      this._telemetryClient.trackEvent({
        name: eventName,
        properties: customProperties
      });

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("EVENT LOG NAME: ".concat(eventName, ", EVENT PROPERTIES: ").concat(JSON.stringify(customProperties)));
      }
    }
  }, {
    key: "logException",
    value: function logException(exceptionObject) {
      if (!this._telemetryClient || !this._telemetryConfigObject.logExceptionsEnabled) return;

      this._telemetryClient.trackException({
        exception: exceptionObject
      });

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("EXCEPTION LOG: " + exceptionObject);
      }
    }
  }, {
    key: "logMetric",
    value: function logMetric(metricName, metricValue) {
      if (!this._telemetryClient || !this._telemetryConfigObject.logMetricesEnabled) return;

      this._telemetryClient.trackMetric({
        name: metricName,
        average: metricValue,
        value: metricValue
      });

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("METRIC LOG Name: ".concat(metricName, ", Metric Value: ").concat(JSON.stringify(metricValue)));
      }
    }
  }, {
    key: "logTrace",
    value: function logTrace(traceMessage) {
      if (!this._telemetryClient || !this._telemetryConfigObject.logTracesEnabled) return;

      this._telemetryClient.trackTrace({
        message: traceMessage
      });

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("TRACE LOG: ".concat(JSON.stringify(traceMessage)));
      }
    }
  }, {
    key: "logDependency",
    value: function logDependency(dependencyObject) {
      if (!this._telemetryClient || !this._telemetryConfigObject.logDependenciesEnabled) return;

      this._telemetryClient.trackDependency(dependencyObject);

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("DEPENDENCY LOG: ".concat(JSON.stringify(dependencyObject)));
      }
    }
  }, {
    key: "logRequest",
    value: function logRequest(requestObject) {
      if (!this._telemetryClient || !this._telemetryConfigObject.logRequestsEnabled) {
        return;
      }

      this._telemetryClient.trackDependency(requestObject);

      if (this._telemetryConfigObject.enableConsoleLog) {
        console.log("REQUEST LOG: ".concat(JSON.stringify(requestObject)));
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      return this._loger;
    }
  }]);

  return Logger;
}();

_defineProperty(Logger, "_loger", new Logger());